import { render, staticRenderFns } from "./DealerListExpand.vue?vue&type=template&id=dd2349c2&"
import script from "./DealerListExpand.vue?vue&type=script&lang=js&"
export * from "./DealerListExpand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports